<template lang="pug">
v-dialog(
  :value='value'
  transition='slide-x-reverse-transition'
  hide-overlay
  fullscreen
  persistent
  lazy
)
  v-card
    v-toolbar(color='primary' class='toolbar' dark flat)
      v-btn(icon @click.native='$emit("input", false)')
        v-icon close
      v-toolbar-title Планировка этажа
      v-spacer
      v-btn(@click='$emit("input", false)' flat)
        v-icon(left) done
        | Готово
    div(class='app-workspace')
      workspace(
        v-if='isRunning'
        :source='source'
        :placements='placements'
        :file-view-box='fileViewBox'
        @update='proxy'
        @remove='$emit("remove", $event)'
        @create='$emit("create", $event)'
      )
        template(slot='extension')
          slot(name='list')
</template>

<script>
import Workspace from './Workspace'

export default {
  props: ['value', 'source', 'placements', 'fileViewBox'],
  components: { Workspace },

  data: () => ({
    results: [],
    isRunning: false
  }),

  mounted() {
    this.isRunning = true
  },

  methods: {
    proxy(results) {
      this.results = results
      this.$emit('update', this.results)
    }
  },

  watch: {
    value(visible) {
      setTimeout(() => {
        this.isRunning = visible
      }, 500)
    }
  }
}
</script>

<style scoped>
.app-workspace {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
}
.toolbar {
  z-index: 10;
}
.app-workspace > div {
  top: 64px;
}
</style>
